import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './SdkRequestForm.css';

export const SdkRequestForm = () => {
	const form = useRef(null);
	const successMessage = 'Request received. Thank you.';

	const [successText, setSuccessText] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [faded, setFaded] = useState(false);

	const sendEmail = (e) => {
		e.preventDefault();
		if (form.current !== null) {
			emailjs.sendForm(
				'service_20ydkup',
				'template_1jl1h8k',
				form.current,
				'scRRIe4BK7-eS0SnY',
			);

			setSuccessText(true);
			setIsDisabled(true);
			setFaded(true);
		}
	};

	return (
		<>
			<div className="SdkRequestContainer">
				<form ref={form} onSubmit={sendEmail}>
					<div className="SdkRequestLabel">Name (Required)</div>
					<input
						className={
							faded ? 'SdkRequestInput SdkRequestInputFaded' : 'SdkRequestInput'
						}
						type="text"
						name="user_name"
						required
						disabled={isDisabled}
					/>
					<div className="SdkRequestLabel">Email (Required)</div>
					<input
						className={
							faded ? 'SdkRequestInput SdkRequestInputFaded' : 'SdkRequestInput'
						}
						type="email"
						name="user_email"
						required
						disabled={isDisabled}
					/>
					<div className="SdkRequestLabel">Company</div>
					<input
						className={
							faded ? 'SdkRequestInput SdkRequestInputFaded' : 'SdkRequestInput'
						}
						type="text"
						name="user_company"
						disabled={isDisabled}
					/>
					<div className="SdkRequestLabel">Country (Required)</div>
					<input
						className={
							faded ? 'SdkRequestInput SdkRequestInputFaded' : 'SdkRequestInput'
						}
						type="text"
						name="user_country"
						required
						disabled={isDisabled}
					/>
					<input
						className={faded ? 'SdkRequestSubmitFaded' : 'SdkRequestSubmit'}
						type="submit"
						value="Submit"
						disabled={isDisabled}
					/>
					{successText && (
						<div className="SdkRequestSuccess">{successMessage}</div>
					)}
				</form>
			</div>
		</>
	);
};
